import React from "react";
import PropTypes from "prop-types";
import { Grid, Box } from "@mui/material";
import Card from "../../../components/Cards/Card";
import NativeObject from "../../../components/NativeObject/NativeObject";
import KpiCard from "../../../components/KpiCard/KpiCard";

const OBJECT_IDS = {
  COBERTURA_BASE: "EBzXWXa",
  COBERTURA_BASE_META: "PcDMrU",
  COBERTURA_BASE_REALIZADO: "MbDQP",
  COBERTURA_BASE_ATINGIMENTO: "tTPwDm",
  COBERTURA_BASE_TABLE: "rPXHRHL",
};

const PerformanceCard = ({ app, segment }) => {
  return (
    <Grid container className="container-cards-kpi">
      <Card app={app} className={"card-kpi-item"} key="PONTOS_TOP_10  " header={{ hardTitle: "Pontos Top 10" }}>
        <KpiCard
          styles={{boxShadow: "none"}}
          app={app}
          valueId={segment === "farma" ? "PkWdV" : OBJECT_IDS.COBERTURA_BASE_META}
          goalValueId={segment === "farma" ? "RnWcKb" : OBJECT_IDS.COBERTURA_BASE_REALIZADO}
          percentageId={segment === "farma" ? "gJyYBeu" : OBJECT_IDS.COBERTURA_BASE_ATINGIMENTO}
          hasProgressBar={true}
          fullView
        />
        {segment !== "farma" && (
          <>
            <Grid container spacing={2}>
              <p className="text-kpi-table" style={{ marginTop: "2rem", marginBottom: "10px", marginLeft: "15px" }}>Ranking</p>
            </Grid>
            <NativeObject
              app={app}
              key={OBJECT_IDS.COBERTURA_BASE_TABLE}
              style={{ width: "100%", height: "40vh" }}
              reference={{ id: OBJECT_IDS.COBERTURA_BASE_TABLE }}
              className={"table-item-ranking"}
            />
          </>
        )}
      </Card>
    </Grid>
  );
};

PerformanceCard.propTypes = {
  app: PropTypes.object.isRequired,
  segment: PropTypes.string,
};

export default PerformanceCard;
